<app-modal-header [title]="title" (closeModal)="closeDialog()"></app-modal-header>

<!-- Loading Indicator -->
<mat-progress-bar *ngIf="loading" mode="buffer"></mat-progress-bar>

<!-- Form Wrapper -->
<div class="form-holder p-6 border border-gray-200 shadow-md rounded-lg bg-white dark:bg-gray-800 dark:border-gray-700">
    <form [formGroup]="form" (ngSubmit)="submitForm()" autocomplete="off" class="dynamic-form space-y-5">

        <!-- CSV File Upload (Upload Mode) -->
        <div *ngIf="mode === 'upload'" class="form-group">
            <label for="csvFile" class="block font-medium text-gray-700 dark:text-gray-300">Upload CSV File</label>
            <input type="file" id="csvFile" (change)="onFileSelected($event)" accept=".csv"
                   class="block w-full px-4 py-2 border rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500">
        </div>

        <!-- Manual Bin Entry (Create Mode) -->
        <div *ngIf="mode === 'create'" class="form-group">
            <label class="block font-medium text-gray-700 dark:text-gray-300">Bin Numbers</label>
            <div formArrayName="binNumbers">
                <div *ngFor="let bin of binNumbers.controls; let i = index" class="flex items-center space-x-3 mt-2">
                    <input type="text" [formControlName]="i" placeholder="Enter Bin Number"
                           class="w-full px-4 py-2 border rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500">
                    <button type="button" (click)="removeBin(i)" *ngIf="binNumbers.length > 1"
                            class="mat-focus-indicator mat-button mat-button-base mat-error px-3 py-1.5 rounded-md shadow-md text-red-600 border-red-600 border">
                        <mat-icon class="mat-icon material-icons">delete</mat-icon>
                    </button>
                </div>
            </div>
            <button type="button" (click)="addBin()"
                    class="mat-focus-indicator mat-button mat-button-base bg-[#025590] text-white px-4 py-2 rounded-md shadow-md mt-3 justify-between items-center">
                <mat-icon class="mat-icon material-icons">add</mat-icon>
                Add Bin
            </button>
        </div>

        <!-- Submit Button -->
        <button type="submit" [disabled]="form.invalid || loading"
                class="w-full bg-[#025590] text-white py-2 px-4 rounded-md shadow-md bg-[#025590]/70 focus:ring focus:ring-primary-300 disabled:opacity-50">
            <mat-icon class="mat-icon material-icons">save</mat-icon> Save
        </button>

    </form>
</div>

<!-- Skeleton Loader -->
<div *ngIf="!form" class="w-full hidden lg:block p-4 border border-gray-200 rounded shadow animate-pulse md:p-6 dark:border-gray-700 col-span-2"
     role="status">
    <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4 mx-auto max-w-[540px]"></div>
    <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
</div>